// @flow

import React, { Fragment } from 'react';
import SettingsIcon from '@atlaskit/icon/glyph/settings';
import { Link } from "react-router-dom";

import {
  GlobalItem,
  GlobalNav,
  GroupHeading,
  HeaderSection,
  Item,
  LayoutManager,
  MenuSection,
  NavigationProvider,
  Separator,
  Wordmark
} from '@atlaskit/navigation-next';


const globalNavPrimaryItems = props => {
  return [
    {
      component: ({ className}) => (
        <Link
          className={className}
          to='/'
        >
          <img
            src={require('../../assets/midrive_icon_white.png')}
            style={{
              height: 20
            }}
          />
        </Link>
      ),
      label: 'midrive',
      size: 'small',
      id: 'midrive',
    },
  ]
};

const globalNavSecondaryItems = props => {
  return [
    {
      component: ({ className}) => (
        <Link
        className={className}
          to='/settings'
        >
          <SettingsIcon />
        </Link>
      ),
      label: 'Settings',
      onClick: () => { },
      size: 'small',
      id: 'Settings',
    },
  ]
};

const MyGlobalNavigation = (props)=> () => (
  <GlobalNav
    primaryItems={globalNavPrimaryItems(props)}
    secondaryItems={globalNavSecondaryItems(props)}
  />
);

const MyProductNavigation= (routes = []) => () => (
  <Fragment>
    <HeaderSection>
      {({ className }) => (
        <div className={className}>
          <Wordmark wordmark={() => (<img style={{ height: '20px' }} src={require('assets/midrive_logo_white.png')}/>)} />
        </div>
      )}
    </HeaderSection>
    <MenuSection>
      {({ className }) => (
        <div className={className}>
          {routes}
        </div>
      )}
    </MenuSection>
  </Fragment>
);

export default (props) => {
  return (
    <NavigationProvider>
      <LayoutManager
        globalNavigation={MyGlobalNavigation(props)}
        productNavigation={MyProductNavigation(props.navComponent)}
        containerNavigation={null}
      >
       {props.children} 
      </LayoutManager>
    </NavigationProvider>
  )
};